import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxPermissionsService } from 'ngx-permissions';
import { ActivatedRoute, Router } from '@angular/router';
import { Dominios, DominiosFilter } from '@core/models/dominio';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DialogService } from '@core/services/dialog.service';
import { DominiosService } from '@core/services/dominios.service';
import { AppSignalDataService } from 'src/app/app-signal-data.service';
import { AuthenticationService } from '@core/auth/authentication.service';
import { MessageService } from '@core/services/message.service';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { DominiosSharedDataService } from '@modules/dominios/dominios-shared-data.service';
import { ColumnOrder } from '@core/table/order';
import { PerfilElement, PerfilEnum } from '@core/models/perfil';
import { RoleEnum } from '@core/models/role';
import { NzButtonSize } from 'ng-zorro-antd/button';

@Component({
  selector: 'app-dominios-list',
  templateUrl: './dominios-list.component.html',
  styleUrls: ['./dominios-list.component.css']
})
export class DominiosListComponent implements OnInit, AfterViewInit {

  dataSet: Dominios[] = [];
  dominiosFilterForm!: FormGroup;
  filtro = new DominiosFilter();
  roleEnum = RoleEnum;
  perfilEnum = PerfilEnum;
  columOrder: ColumnOrder | undefined;

  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;

  size: NzButtonSize = 'large';

  constructor(
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private ngxPermissionService: NgxPermissionsService,
    private changeDetector: ChangeDetectorRef,
    public route: ActivatedRoute,
    private dominiosService: DominiosService,
    private authenticationService: AuthenticationService,
    private messageService: MessageService,
    private router: Router,
    private modalService: NzModalService,
    private dominiosSharedDataService: DominiosSharedDataService,
    private appSignalDataService: AppSignalDataService,
  ) { }

  ngOnInit() {

    this.dominiosFilterForm = this.formBuilder.group({
      nome: [],
      descricao: [],
    });

    this.dominiosSharedDataService.updateList$.subscribe(() => {
      this.consultar();
    });
  }

  ngAfterViewInit(): void {
    this.changeDetector.detectChanges();
    this.paginator.change.subscribe((val) => {
      this.consultar(this.columOrder);
    });
    this.consultar();
  }

  pesquisar(): void {
    this.filtro = { ...this.dominiosFilterForm.value };
    this.paginator.reset();
    this.consultar();
  }

  consultar(sortParams?: any): void {
    let params = {};
    if (sortParams) {
      params = { ...sortParams };
    }
    this.dominiosService.consultarSemDominio(this.filtro, this.paginator.pagination, params)
      .subscribe((data) => {
        const nomesFiltrar = ['SITUACAO_ASSOCIADA'];
        const dataFiltrada = data.content.filter((item: Dominios) => {
          const nome = (item.name || '').toString().trim().toUpperCase();
          return !nomesFiltrar.includes(nome);
        });
        this.dataSet = dataFiltrada;
        this.paginator.totalItens = data.totalElements;
      });
  }

  sort(event: any) {
    const itemSelected = event.sort.find((x: any) => x.value);
    if (itemSelected) {
      this.columOrder = {
        sortField: itemSelected.key,
        sortOrder: itemSelected.value
      };
      this.consultar(this.columOrder);
    } else {
      this.columOrder = undefined;
      this.consultar();
    }
  }

  // loadData removido, pois o sort é tratado direto no consultar

  accessarDominio(obj: Dominios): void {

    // console.log("DOMINIOS", obj);

    const dominio = obj.name?.toLowerCase().replaceAll('_','-');

    this.router.navigate([`/dominios/${dominio}`]);

    //if (obj) {
    //  this.dominiosSharedDataService.setDominioSelecionado(obj);
    //  const target = obj.nome?.toLowerCase().replaceAll('_','-');
    //  this.router.navigate([`/dominios/${target}`]);
    //}

    //if (this.ngxPermissionService.getPermission(RoleEnum.PerfilLeitura))
    //  this.router.navigate([`/perfil/editar/${obj.id}`]);
    //else
    //  this.router.navigate([`/perfil/visualizar/${obj.id}`]);
  }

  get txtNome() {
    return this.dominiosFilterForm.controls['nome'];
  }

  get txtDescricao() {
    return this.dominiosFilterForm.controls['descricao'];
  }
}
